import { authorizedApi } from '../network/authorized-api';
import { Pricing } from '@flyblack/common/domains';

export const getFriendReferralCreditValue: () => Promise<Pricing> = () => authorizedApi.get(`/v1/admin/referral-bonus`);

export const setFriendReferralCreditsValue: (currency, value) => Promise<number> = (currency, value) =>
  authorizedApi.put(`/v1/admin/referral-bonus`, { currency, value });
